<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BNav
      class="scrollable-x-tabs no-scrollbar nav-other-events-tabs"
      pills
    >
      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>

      <BNavItem
        :active="getActiveRoute('activities')"
        :to="{
          name: 'rsm.officers.other-events'
        }"
      >
        <i :class="iconState('fa-file-circle-question', getActiveRoute('activities'))" /> Activities
      </BNavItem>

      <BNavItem
        :active="getActiveRoute('reports')"
        :to="{
          name: 'rsm.officers.other-events.reports'
        }"
      >
        <i :class="iconState('fa-file-chart-column', getActiveRoute('reports'))" /> Reports
      </BNavItem>

      <div class="nav-item">
        <div
          class="d-flex align-items-center position-absolute"
          style="right: 20px; padding: 2px 1px; height: 38px;"
        >
          <i
            class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
            style="font-size: 20px;"
          />
        </div>
      </div>
    </BNav>

    <div class="py-2">
      <RouterView
        ref="tableView"
      />
    </div>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import MxMisc from '@/mixins/misc'

export default {
  name: 'OtherEvents',

  mixins: [
    MxMisc
  ],

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  mounted () {
    if (this.currentUser) {
      this.$nextTick(() => {
        this.attachArrowScroller('.nav-other-events-tabs')
      })
    }
  },

  beforeDestroy () {
    this.detachArrowScroller('.nav-other-events-tabs')
  },

  methods: {
    getTabRoute (tabName) {
      return `/rsm/officers/tracking/other-activities/${tabName}`
    },

    getActiveRoute (tabName) {
      return this.$route.path === this.getTabRoute(tabName)
    }
  }
}
</script>
